import { useTranslation } from "react-i18next";
import { Flex } from "antd";
import { AppButton } from "@/shared/Components";
import { AvatarCheckIcon } from "@/shared/icons";
import type { Props } from "./types";
import styles from "./styles.module.scss";

export const Mobile = ({ onClick }: Props) => {
  const { t } = useTranslation();

  const title = t("passwordRecoveryPage.successTitle");

  return (
    <>
      <Flex vertical gap={16} align="center" className={styles.content}>
        <AvatarCheckIcon fill="#34C759" />
        <h1 className={styles.title}>{title}</h1>
      </Flex>
      <AppButton type="primary" onClick={onClick} className={styles.button}>
        {t("passwordRecoveryPage.toLogin")}
      </AppButton>
    </>
  );
};
